import React from 'react';
import get from 'lodash.get';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectors as configSelectors, Configuration, Messages } from 'services/configuration';
import { selectors as ticketingSelectors } from 'services/ticketing';
import { EventViewProps } from '../types';
import { EventTiers } from './EventTiers';
import { Layout } from './Layout';

const EventView: React.FC<EventViewProps> = (props: EventViewProps) => {
  const { event, tiers, tierSelection, getImageUrl, updateTier } = props;
  const { t, i18n } = useTranslation();

  const config = useSelector(configSelectors.selectConfiguration) as Configuration;
  const ticketingPath = useSelector(ticketingSelectors.selectTicketingConfigPath);
  const upsellProducts = useSelector(ticketingSelectors.selectUpsellProducts);

  const messages = get(config, `messaging.${i18n.language}.tierPage`);
  const header = get(messages, 'header', t('tierSelection.tierMessagingHeader'));
  const subheader = get(messages, 'message', t('tierSelection.tierMessagingSubHeader'));
  const upsellMessages: Messages = get(
    config,
    `${ticketingPath}.productAvailabilityAndSelection.upsell.tierSelectionMessages`,
    {}
  );
  const upsellHeader = get(upsellMessages, `header.${i18n.language}`, '');
  const upsellSubheader = get(upsellMessages, `subheader.${i18n.language}`, '');

  const selectedEl = React.useRef<HTMLDivElement>(null);

  return (
    <Layout
      headerText={upsellProducts.length > 0 && upsellHeader ? upsellHeader : header}
      subHeaderText={upsellProducts.length > 0 && upsellSubheader ? upsellSubheader : subheader}
      hasTickets={Boolean(tiers && Object.keys(tiers).length && tierSelection)}
      refreshModel={selectedEl}
    >
      <EventTiers
        event={event}
        tiers={tiers}
        tierSelection={tierSelection}
        tierSelectionKey={'tier'}
        getImageUrl={getImageUrl}
        onTileClick={(tier: string) => updateTier(tier)}
      />
    </Layout>
  );
};

export default EventView;
